(function () {
    'use strict';

    function chatlioService($window, sessionDataService) {
        document.addEventListener('chatlio.ready', function (e) {
            initialize();
        }, false);

        function initialize() {
            sessionDataService.loadSession().then(function (data) {
                if (!$window._chatlio) {
                    return;
                }

                if (data.IsGuest) {
                    $window._chatlio.configure({
                        requireInfo: true
                    });
                } else {
                    $window._chatlio.identify(data.UserName,
                        {
                            name: data.EntityType === 'Portal Administrator'
                                ? 'Super Admin'
                                : data.Entity.Contact.FirstName + ' ' + data.Entity.Contact.LastName,
                            email: data.UserName,
                            site: data.SiteName
                        });
                }
                $window._chatlio.show();
            });
        }

        return {
            initialize: initialize
        }
    }

    chatlioService.$inject = ['$window', 'sessionDataService'];

    angular.module('ecap.common').service('chatlioService', chatlioService);
})();
